<app-admin-dashboard>
    <p-card header="Carga masiva de pallets en ordenes">
        <p>
            Carga información de pallets a ordenes de programa, encuentra el formato <a [href]="uploadFormatUrl">aquí</a>.
        </p>
        <div class="col-6">
            <h3>Seleccionar archivo Excel</h3>
            <p-fileUpload name="sheetPdf[]"
                #imagesUploader
                (onSelect)="onSelect($event, imagesUploader)"
                (onRemove)="onRemove($event, imagesUploader)"
                (onClear)="onClear($event, imagesUploader)"
                [showUploadButton]="false"
                [multiple]="false"
                accept=".xlsx"
                [fileLimit]="1"
                [files]="uploadFile"
                [maxFileSize]="3000000"
                chooseLabel="Seleccionar">
                <ng-template pTemplate="toolbar">
                </ng-template>
                <ng-template pTemplate="content">
                </ng-template>
            </p-fileUpload>
            <div class="col-12 flex justify-content-end">
                <p-button label="Cargar" (onClick)="sendFiles()" [loading]="loading" [disabled]="uploadDisabled"></p-button>
            </div>
        </div>
    </p-card>
</app-admin-dashboard>
